import NovaSolicitacao from '@/components/NovaSolicitacao'
import { useNavigate } from 'react-router-dom'

export default function NovaSolicitacaoPage() {
  const navigate = useNavigate()
  return (
    <NovaSolicitacao
      onSaved={() => navigate('/solicitacoes')}
      onCancel={() => navigate('/solicitacoes')}
    />
  )
}
